module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEwSURBVHgBrVNtEcIwDE05/jMcVAIOmARQwBwggaEAHIADJGwOAAWbgw0FJYEUstKOjuPdZR/5eH1NU4A/Q/UFjTEJvmZoGq1Ga5VSFxgKJMrQCuNHRXFPjf7ws7PwEJDv7PHPRO2enC5ZxckNWs5b7rSA1cu8BceOLmElVtbQ3xLtKF51CHnVKDKH+ChIG0lo1WWRRAmrJDsJUkPBVPwnkYSVCWAEzzkjlDhjLcQhNIvtGB9WVQ2RwIWXoRgptKqm8AcQYc3fc/gB2LY12uHVfz6xhnuaDuCy82g+asU8nWEAWNljfn0rWZWHSLKNUJf5EjKRQNdKB4ioRTuRm8u4cknxtYP3KJXwnLkb/9PBpaJkiyOUw5etaNO9oz4UoQNUfcSshm7ShN1XUoyqylDdHeNZ8HFASbcwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/refresh.png
// module id = HeDi
// module chunks = 0